let standardCrud = {
    read: {
        params: { action: 'get' }
    },
    create: {
        params: { action: 'create' }
    },
    update: {
        params: { action: 'update' }
    },
    destroy: {
        params: { action: 'delete' }
    }
}

export default {
    guardiansGuardians: {
        defaults: {
            endpoint: 'guardians.php?property=guardian',
            rootProperty: 'guardians'
        },
        ...standardCrud
    },
    guardiansStudents: {
        defaults: {
            endpoint: 'guardians.php?property=student',
            rootProperty: 'students'
        },
        ...standardCrud
    },
    guardiansUserGuardian: {
        defaults: {
            endpoint: 'guardians.php?property=user_guardian',
            rootProperty: 'guardians'
        },
        ...standardCrud
    },
}